<script lang="ts">
	import { env } from '$env/dynamic/public';
	import { t } from '$lib/i18n';

	import '../app.css';
	let searching = false;
</script>

<header class="transition-all w-full bg-slate-50 flex items-center justify-center">
	<div class="max-w-[75%] w-full lg:w-3/4">
		<div class="flex flex-row items-center justify-between h-36">
			<a data-sveltekit-reload href="/" class="custom-logo-link" rel="home" aria-current="page">
				<img
					src="/big-logo.png"
					class="max-h-[100px] bg-slate-50 -ml-6 lg:ml-28 mt-4 max-w-[160px]"
					alt="b2b expertise logo"
				/>
			</a>
			<div class="hidden flex-row justify-center items-center searchBreakpoint:flex">
				<div class="flex flex-row mt-10 my-2">
					<form method="get" action="/search" class="flex mr-4 border rounded-md">
						<input
							type="search"
							name="s"
							class="rounded-l-md h-10 border-none text-xs md:w-72 sm:w-48 pt-[11px]"
							placeholder={$t('common.search-placeholder', {
								default: 'search whitepapers, topics, case studies etc'
							})}
							value=""
						/>
						<button
							type="submit"
							class="flex items-center justify-center transition-all rounded-r-md bg-main-dark h-10 w-32 text-white hover:bg-white border-main-dark border hover:text-main-dark"
							>{$t('common.search', { default: 'Search ' })}
						</button>
					</form>
				</div>
			</div>
			<div class="flex flex-row justify-center items-center searchBreakpoint:hidden">
				{#if !searching}
					<svg
						class="mt-6"
						on:click={() => (searching = true)}
						on:keypress={() => (searching = true)}
						width="26px"
						height="26px"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
						><g id="SVGRepo_bgCarrier" stroke-width="0" /><g
							id="SVGRepo_tracerCarrier"
							stroke-linecap="round"
							stroke-linejoin="round"
						/><g id="SVGRepo_iconCarrier">
							<g id="Interface / Search_Magnifying_Glass">
								<path
									id="Vector"
									d="M15 15L21 21M10 17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10C17 13.866 13.866 17 10 17Z"
									stroke="#000000"
									stroke-width="2"
									stroke-linecap="round"
									stroke-linejoin="round"
								/>
							</g>
						</g></svg
					>
				{:else}
					<div class="fixed inset-0 flex items-center justify-center bg-gray-200 z-50">
						<button class="absolute top-6 right-6 m-2">
							<svg
								on:click={() => (searching = false)}
								on:keypress={() => (searching = false)}
								xmlns="http://www.w3.org/2000/svg"
								viewBox="0 0 24 24"
								fill="none"
								stroke="currentColor"
								stroke-width="2"
								stroke-linecap="round"
								stroke-linejoin="round"
								class="w-6 h-6"
							>
								<path d="M6 18L18 6M6 6l12 12" />
							</svg>
						</button>
						<div class="relative">
							<form
								on:submit={() => (searching = false)}
								method="get"
								action="/search"
								class="flex mr-4 border rounded-md"
							>
								<input
									type="search"
									name="s"
									class="rounded-l-md h-10 border-none text-xs md:w-72 sm:w-48 pt-[11px]"
									placeholder="Search for whitepapers, topics, and case studies"
								/>
								<button
									on:click={() => (searching = false)}
									on:keypress={() => (searching = false)}
									type="submit"
									class="flex items-center justify-center transition-all rounded-r-md bg-main-dark h-10 w-32 text-white hover:bg-white border-main-dark border hover:text-main-dark"
									>Search</button
								>
							</form>
						</div>
					</div>
				{/if}
			</div>
		</div>
	</div>
</header>
<slot />
<footer
	id="colophon"
	class="md:mt-[0px] bg-dark-gray w-full flex-none flex items-center justify-center text-white h-[150px] md:h-28"
>
	<div
		class=" w-[75%] lg:max-w-none md:max-w-3xl flex flex-col md:flex-row lg:flex-row justify-between"
	>
		<div class="flex flex-col md:flex-row md:items-center">
			<nav class="mb-4 flex-grow flex flex-col text-lg md:ml-10" />
		</div>
		<div class="flex-shrink">
			<p class="text-left md:text-right lg:text-right text-sm">
				<a href="/unsubscribe"
					>{$t('common.footer.update-preferences', { default: `Update your Preferences` })}</a
				>
				<br />
				<a target="_blank" href="/privacy"
					>{$t('common.footer.privacy-policy', { default: `Privacy Notice` })}</a
				>
				<br />
				<!-- {$t('common.footer.copyright', { default: `© 2024 Berne UK LTD All Rights Reserved` })} -->
			</p>
		</div>
	</div>
</footer>
